import { PlanType } from 'models/bfmc';

// export enum WorkshopEnum {
//     'workshop_1',
//     'workshop_2',
//     'workshop_3',
//     'workshop_4',
// }

export enum BfWorkshopEnum {
    'bf_workshop_1',
    'bf_workshop_2',
    'bf_workshop_3',
    'bf_workshop_4',
}

export enum FaftWorkshopEnum {
    'faft_pre_workshop',
    'faft_workshop_1',
    'faft_workshop_2_3',
    'faft_workshop_4',
}

// export type WorkshopId = keyof typeof WorkshopEnum;
export type BfWorkshopId = keyof typeof BfWorkshopEnum;
export type FaftWorkshopId = keyof typeof FaftWorkshopEnum;

// export const workshopIds = Object.keys(WorkshopEnum).filter((x) =>
//     Number.isNaN(+x),
// ) as WorkshopId[];
export const bfWorkshopIds = Object.keys(BfWorkshopEnum).filter((x) =>
    Number.isNaN(+x),
) as BfWorkshopId[];
export const faftWorkshopIds = Object.keys(FaftWorkshopEnum).filter((x) =>
    Number.isNaN(+x),
) as FaftWorkshopId[];

// export enum WorkflowEnum {
//     null,
//     'not_started',
//     'workshop_1_commenced',
//     'workshop_1_processing',
//     'workshop_1_completed',
//     'workshop_2_commenced',
//     'workshop_2_processing',
//     'workshop_2_completed',
//     'workshop_3_commenced',
//     'workshop_3_processing',
//     'workshop_3_completed',
//     'workshop_4_commenced',
//     'workshop_4_processing',
//     'workshop_4_completed',
// }

export enum BfWorkflowEnum {
    'bf_not_started',
    'bf_workshop_1_commenced',
    'bf_workshop_1_processing',
    'bf_workshop_1_completed',
    'bf_workshop_2_commenced',
    'bf_workshop_2_processing',
    'bf_workshop_2_completed',
    'bf_workshop_3_commenced',
    'bf_workshop_3_processing',
    'bf_workshop_3_completed',
    'bf_workshop_4_commenced',
    'bf_workshop_4_processing',
    'bf_workshop_4_completed',
    'bf_workshop_4_approved',
}

export enum FaftWorkflowEnum {
    'faft_not_started',
    'faft_pre_workshop_commenced',
    'faft_pre_workshop_completed',
    'faft_workshop_1_commenced',
    'faft_workshop_1_completed',
    'faft_workshop_2_3_commenced',
    'faft_workshop_2_3_completed',
    'faft_workshop_4_commenced',
    'faft_workshop_4_completed',
    'faft_workshop_4_approved',
}

export const endorsedIds: (
    | keyof typeof FaftWorkflowEnum
    | keyof typeof BfWorkflowEnum
)[] = ['faft_workshop_4_approved', 'bf_workshop_4_approved'];

export const postFaftPrioritisationStages: (keyof typeof FaftWorkflowEnum)[] = [
    'faft_workshop_2_3_commenced',
    'faft_workshop_2_3_completed',
    'faft_workshop_4_commenced',
    'faft_workshop_4_completed',
];

// export type WorkflowId = keyof typeof WorkflowEnum;
export type BfWorkflowId = keyof typeof BfWorkflowEnum;
export type FaftWorkflowId = keyof typeof FaftWorkflowEnum;

// export const workflowIds = Object.keys(WorkflowEnum).filter((x) =>
//     Number.isNaN(+x),
// ) as WorkflowId[];

export const bfWorkflowIds = Object.keys(BfWorkflowEnum).filter((x) =>
    Number.isNaN(+x),
) as BfWorkflowId[];
export const faftWorkflowIds = Object.keys(FaftWorkflowEnum).filter((x) =>
    Number.isNaN(+x),
) as FaftWorkflowId[];

export type Scope = 'group' | 'individual';

export interface Workshop {
    id: BfWorkshopId | FaftWorkshopId;
    name: string;
    task: string;
    action: string;
}

export interface Workflow {
    id: BfWorkflowId | FaftWorkflowId;
    workshopId: BfWorkshopId | FaftWorkshopId;
    scope: Scope;
    status: string;
    next?: Workflow;
    previous?: Workflow;
}

export interface ContextualWorkflow extends Workflow {
    date?: Date;
    next?: ContextualWorkflow;
    previous?: ContextualWorkflow;
}

export const bfWorkshops: Record<BfWorkshopId, Workshop> = {
    bf_workshop_1: {
        id: 'bf_workshop_1',
        name: 'Workshop 1 - Data Validation',
        task:
            'Review feedback from the Stakeholder & Community Consultation process and review the input data layers. ' +
            'The preliminary risk assessment maps will help by highlighting any errors in the base data. Check asset layers for any new, ' +
            'significant assets (e.g. new residential development areas) and check that the modelled ignition layer covers areas of concern.',
        action: 'Use the comment tool and Red Line to identify any errors or suggested modifications to the input data. Endorse the data for use in the risk assessment process.',
    },
    bf_workshop_2: {
        id: 'bf_workshop_2',
        name: 'Workshop 2 - Risk Assessment',
        task: 'Review the Risk Results and identify Pilot Areas, Standards and Methodologies.',
        action: 'Use the Pilot Area map tools to identify Pilot Areas, select Standards and Methodologies, and record the Risk Drivers.',
    },
    bf_workshop_3: {
        id: 'bf_workshop_3',
        name: 'Workshop 3 - Review',
        task: 'Review the updated Risk data and arrange the public exhibition process.',
        action: 'Use the map tools to modify the Pilot Areas (if required) and endorse BMAP for public exhibition.',
    },
    bf_workshop_4: {
        id: 'bf_workshop_4',
        name: 'Workshop 4 - Endorsement',
        task: 'Review the comments from public exhibition.',
        action: 'Amend the BMAP as required (Pilot Areas, Standards and Methodologies) and endorse the BMAP.',
    },
};

export const faftWorkshops: Record<FaftWorkshopId, Workshop> = {
    faft_pre_workshop: {
        id: 'faft_pre_workshop',
        name: 'Pre-Workshop Consultation(s)',
        task: `Each BMC member agency is encouraged to conduct internal consultations with its subject matter experts and relevant stakeholders to identify strategic, tactical, problematic, and potential new trails based on their knowledge and experiences.`,
        action: 'Conduct a facilitation presentation, followed by a collaborative map markup session where agencies and volunteers provide internal agency insights and data on fire trail usability, condition, and access needs.',
    },
    faft_workshop_1: {
        id: 'faft_workshop_1',
        name: 'Workshop 1 – Introduction and Trail Identification',
        task: `Review inputs from pre-workshop consultations and identify fire trails based on spatial data, land use factors, and historical insights. Classify trails into Strategic and Tactical.`,
        action: 'Use BFRP to conduct spatial analysis, review trail classifications, and update draft plans based on identified issues like environmental impacts and changes in land tenure.',
    },
    faft_workshop_2_3: {
        id: 'faft_workshop_2_3',
        name: 'Workshop 2 & 3 – Trail Prioritisation, Complexity & Treatment',
        task: `Refine the trail list, assess priority levels for upgrades, and address the complexity of planned works. Develop a five-year treatment schedule for critical fire trails.`,
        action: `Over two workshops, present prioritisation and complexity matrices to BMC members, update ratings collaboratively, and finalise the Fire Trail Treatment Register for high-priority trails.`,
    },
    faft_workshop_4: {
        id: 'faft_workshop_4',
        name: 'Workshop 4 – Endorsement of Plan',
        task: `Secure BMC's formal endorsement for the final FAFT Plan, including all documentation and proposed treatment schedules.`,
        action: 'Review the final draft, facilitate a formal vote or consensus among members, and document the endorsement process. Prepare for submission to the State Bushfire Coordination Committee (SBCC).',
    },
};

export const bfWorkflows: Record<BfWorkflowId, Workflow> = {
    bf_not_started: {
        id: 'bf_not_started',
        scope: 'group',
        workshopId: 'bf_workshop_1',
        status: 'Not Started',
    },
    bf_workshop_1_commenced: {
        id: 'bf_workshop_1_commenced',
        scope: 'group',
        workshopId: 'bf_workshop_1',
        status: 'Preliminary Data Available',
    },
    bf_workshop_1_processing: {
        id: 'bf_workshop_1_processing',
        scope: 'group',
        workshopId: 'bf_workshop_1',
        status: 'Comments closed',
    },
    bf_workshop_1_completed: {
        id: 'bf_workshop_1_completed',
        scope: 'group',
        workshopId: 'bf_workshop_1',
        status: 'Completed, processing data',
    },

    bf_workshop_2_commenced: {
        id: 'bf_workshop_2_commenced',
        scope: 'group',
        workshopId: 'bf_workshop_2',
        status: 'Risk Data Available',
    },
    bf_workshop_2_processing: {
        id: 'bf_workshop_2_processing',
        scope: 'group',
        workshopId: 'bf_workshop_2',
        status: 'Comments closed',
    },
    bf_workshop_2_completed: {
        id: 'bf_workshop_2_completed',
        scope: 'group',
        workshopId: 'bf_workshop_2',
        status: 'Completed, processing data',
    },

    bf_workshop_3_commenced: {
        id: 'bf_workshop_3_commenced',
        scope: 'group',
        workshopId: 'bf_workshop_3',
        status: 'Updated Risk Data Available',
    },
    bf_workshop_3_processing: {
        id: 'bf_workshop_3_processing',
        scope: 'individual',
        workshopId: 'bf_workshop_3',
        status: 'Comments closed',
    },
    bf_workshop_3_completed: {
        id: 'bf_workshop_3_completed',
        scope: 'individual',
        workshopId: 'bf_workshop_3',
        status: 'Approved for Public Exhibition',
    },

    bf_workshop_4_commenced: {
        id: 'bf_workshop_4_commenced',
        scope: 'individual',
        workshopId: 'bf_workshop_4',
        status: 'Review Public Exhibition comments',
    },
    bf_workshop_4_processing: {
        id: 'bf_workshop_4_processing',
        scope: 'individual',
        workshopId: 'bf_workshop_4',
        status: 'Finalised for BMC Endorsement',
    },
    bf_workshop_4_completed: {
        id: 'bf_workshop_4_completed',
        scope: 'individual',
        workshopId: 'bf_workshop_4',
        status: 'BMC Endorsed',
    },
    bf_workshop_4_approved: {
        id: 'bf_workshop_4_approved',
        scope: 'individual',
        workshopId: 'bf_workshop_4',
        status: 'SBCC Approved',
    },
};

export const faftWorkflows: Record<FaftWorkflowId, Workflow> = {
    faft_not_started: {
        id: 'faft_not_started',
        scope: 'individual',
        workshopId: 'faft_pre_workshop',
        status: 'Not Started',
    },
    faft_pre_workshop_commenced: {
        id: 'faft_pre_workshop_commenced',
        scope: 'individual',
        workshopId: 'faft_pre_workshop',
        status: 'Commenced',
    },
    faft_pre_workshop_completed: {
        id: 'faft_pre_workshop_completed',
        scope: 'individual',
        workshopId: 'faft_pre_workshop',
        status: 'Completed',
    },
    faft_workshop_1_commenced: {
        id: 'faft_workshop_1_commenced',
        scope: 'individual',
        workshopId: 'faft_workshop_1',
        status: 'Commenced',
    },
    faft_workshop_1_completed: {
        id: 'faft_workshop_1_completed',
        scope: 'individual',
        workshopId: 'faft_workshop_1',
        status: 'Completed',
    },
    faft_workshop_2_3_commenced: {
        id: 'faft_workshop_2_3_commenced',
        scope: 'individual',
        workshopId: 'faft_workshop_2_3',
        status: 'Commenced',
    },
    faft_workshop_2_3_completed: {
        id: 'faft_workshop_2_3_completed',
        scope: 'individual',
        workshopId: 'faft_workshop_2_3',
        status: 'Completed',
    },
    faft_workshop_4_commenced: {
        id: 'faft_workshop_4_commenced',
        scope: 'individual',
        workshopId: 'faft_workshop_4',
        status: 'Commenced',
    },
    faft_workshop_4_completed: {
        id: 'faft_workshop_4_completed',
        scope: 'individual',
        workshopId: 'faft_workshop_4',
        status: 'Endorsed',
    },
    faft_workshop_4_approved: {
        id: 'faft_workshop_4_approved',
        scope: 'individual',
        workshopId: 'faft_workshop_4',
        status: 'Approved',
    },
};

export const getWorkflow = (
    planType: PlanType,
    id?: BfWorkflowId | FaftWorkflowId | null,
) => {
    if (!id) {
        if (planType === 'bfrmp') return bfWorkflows.bf_not_started;
        else return faftWorkflows.faft_not_started;
    }
    if (planType === 'bfrmp') {
        const bfId = id as BfWorkflowId;
        return bfWorkflows[bfId]
            ? bfWorkflows[bfId]
            : bfWorkflows.bf_not_started;
    } else {
        const faftId = id as FaftWorkflowId;
        return faftWorkflows[faftId]
            ? faftWorkflows[faftId]
            : faftWorkflows.faft_not_started;
    }
};

// Use the order of the workflow Id's in the Enum as the order of the steps
bfWorkflowIds.forEach((id, idx, arr) => {
    const ws = bfWorkflows[id];
    if (idx > 0) ws.previous = bfWorkflows[arr[idx - 1]];
    if (idx < arr.length - 1) ws.next = bfWorkflows[arr[idx + 1]];
});
faftWorkflowIds.forEach((id, idx, arr) => {
    const ws = faftWorkflows[id];
    if (idx > 0) ws.previous = faftWorkflows[arr[idx - 1]];
    if (idx < arr.length - 1) ws.next = faftWorkflows[arr[idx + 1]];
});

export const getWorkshopStatus = (
    planType: PlanType,
    workshop: Workshop,
    latestStatus: BfWorkflowId | FaftWorkflowId,
) => {
    if (planType === 'bfrmp') {
        const latestBfStatus = latestStatus as BfWorkflowId;
        const latestStatusIndex = bfWorkflowIds.indexOf(latestBfStatus);
        return bfWorkflowIds.reduce<BfWorkflowId | null>((acc, id, idx) => {
            // Workshop hasn't commenced if we haven't found it by latestStatusIndex
            if (idx > latestStatusIndex) return acc;
            const stage = bfWorkflows[id];
            if (stage.workshopId === workshop.id) return id;
            return acc;
        }, null);
    } else {
        const latestFaftStatus = latestStatus as FaftWorkflowId;
        const latestStatusIndex = faftWorkflowIds.indexOf(latestFaftStatus);
        return faftWorkflowIds.reduce<FaftWorkflowId | null>((acc, id, idx) => {
            // Workshop hasn't commenced if we haven't found it by latestStatusIndex
            if (idx > latestStatusIndex) return acc;
            const stage = faftWorkflows[id];
            if (stage.workshopId === workshop.id) return id;
            return acc;
        }, null);
    }
};
